export default __webpack_public_path__ + "static/media/integrations.b5dbe891.png";